import React from 'react';
import { Button, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';

export default function LandingFinalCta({ content, settings }) {
  const cta = content?.final_cta || {};

  if (!cta?.title && !cta?.subtitle && !cta?.button_text) return null;

  const sectionStyle = {
    background: `linear-gradient(135deg, ${settings?.primary_color || '#0d6efd'} 0%, ${
      settings?.secondary_color || '#4dabf7'
    } 100%)`,
  };

  return (
    <section className="landing-final-cta" style={sectionStyle}>
      <Container>
        <div className="landing-final-cta__inner">
          {cta?.eyebrow ? (
            <span className="landing-final-cta__eyebrow">{cta.eyebrow}</span>
          ) : null}

          {cta?.title ? <h2 className="landing-final-cta__title">{cta.title}</h2> : null}

          {cta?.subtitle ? (
            <p className="landing-final-cta__subtitle">{cta.subtitle}</p>
          ) : null}

          {cta?.button_text && cta?.button_url ? (
            <div className="landing-final-cta__actions">
              <Button
                as={Link}
                to={cta.button_url}
                variant="light"
                className="landing-final-cta__button"
              >
                {cta.button_text}
              </Button>
            </div>
          ) : null}
        </div>
      </Container>
    </section>
  );
}